<template>
	<div>
		<div class="bottom">
			<div class="title">我的推广</div>
			<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
				text-color="#08243C">
				<el-menu-item index="1">下线推广</el-menu-item>
				<el-menu-item index="2">我的下线</el-menu-item>
				<el-menu-item index="3">我的收益</el-menu-item>
			</el-menu>
      <div class="search-box" v-show="activeIndex == '2'">
        <div class="search">
          <el-input placeholder="用户名" v-model="keywords">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-button type="warning" style="margin-left: 33px" @click="search">搜索</el-button>
        </div>
        <div class="partition">
          <div class="partition-text">推广级别</div>
          <el-select v-model="type" placeholder="请选择" @change="change">
            <el-option label="全部" value=""></el-option>
            <el-option label="一级分销" value="1"></el-option>
            <el-option label="二级分销" value="2"></el-option>
          </el-select>
        </div>
      </div>
      <div class="top" v-show="activeIndex == '3'">
        <div class="top-item">
          <div class="num">{{ mouth_money }}</div>
          <div class="text">新款区域当月</div>
        </div>
        <div class="shu"></div>
        <div class="top-item">
          <div class="num">{{ year_money }}</div>
          <div class="text">新款区域当年</div>
        </div>
        <div class="shu"></div>
        <div class="top-item">
          <div class="num">{{ yc_mouth_money }}</div>
          <div class="text">原创区域当月</div>
        </div>
        <div class="shu"></div>
        <div class="top-item">
          <div class="num">{{ yc_year_money }}</div>
          <div class="text">原创区域当年</div>
        </div>
      </div>
			<div class="content" style="margin-top: 39px">
				<div v-show="activeIndex == '1'">
					<div
						style="font-size: 14px;padding: 0 24px 31px 24px;border-bottom: 1px rgba(8, 36, 60, 0.2) solid;">
						<div v-for="(item,index) in content" :style="index>0?'margin-top: 27px;':''">
							{{index+1}}.{{ item }}
						</div>
					</div>
					<div style="padding: 0 24px;">
						<div style="color: rgba(8, 36, 60, 1);font-size: 16px;margin-top: 31px;">您的推广链接</div>
						<div
							style="background-color: RGBA(240, 242, 244, 1);padding: 18px 26px;display: flex;justify-content: space-between;align-items: center;margin-top: 27px;width: 70%;">
							<div style="color: rgba(136, 136, 136, 1);">
								{{ message }}
							</div>
							<div style="color: rgba(230, 102, 23, 1);cursor: pointer;" v-clipboard:copy="message"
								v-clipboard:success="onCopy">复制</div>
						</div>
						<div style="margin-top: 29px;">
							<div style="border: 1rpx red solid;" id="qrcode" ref="qrcode"></div>
							<!-- <img src="../../assets/erweima.png" style="width: 180px;height: 180px;"> -->
						</div>
					</div>
				</div>
				<el-table :data="tableData" style="width: 100%" v-show="activeIndex == '2'">
					<el-table-column prop="users_id" label="ID" align="center">
					</el-table-column>
					<el-table-column prop="nickname" label="昵称" align="center">
					</el-table-column>
					<el-table-column prop="archives_count" label="作品数量" align="center">
					</el-table-column>
          <el-table-column prop="parent_count" label="推广人数" align="center">
          </el-table-column>
          <el-table-column prop="order_count" label="订单数" align="center">
          </el-table-column>
          <el-table-column prop="parent_level_name" label="推广级别" align="center">
          </el-table-column>
					<el-table-column prop="reg_time" label="注册时间" align="center">
					</el-table-column>
				</el-table>
				<el-table :data="tableData1" style="width: 100%" v-show="activeIndex == '3'">
					<el-table-column prop="memo" label="奖励缘由" align="center">
					</el-table-column>
					<el-table-column prop="create_time" label="奖励时间" align="center">
					</el-table-column>
          <el-table-column prop="relation_type_name" label="奖励类型" align="center">
          </el-table-column>
					<el-table-column prop="money" label="推广收益" align="center">
					</el-table-column>
				</el-table>
			</div>
			<div class="page-box" v-show="activeIndex == '2'">
				<div class="pages">
					<el-pagination @current-change="handleCurrentChange" :current-page="page" :page-size="size"
						layout="total, prev, pager, next ,jumper" :total="count">
					</el-pagination>
				</div>
			</div>
			<div class="page-box" v-show="activeIndex == '3'">
				<div class="pages">
					<el-pagination @current-change="handleCurrentChange" :current-page="page" :page-size="size"
						layout="total, prev, pager, next ,jumper" :total="count1">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import QRCode from "qrcodejs2";
	import {
		userArticleList,
		topCate,
		extensionMyPromotion,
		extensionMyReferrals,
		extensionMyEarnings
	} from "../../request/api";
	export default {
		data() {
			return {
				activeIndex: "1", //menu 默认显示
				tableData: [],
				tableData1: [],
				keyWords: "",
				arctype: "",
				choose: "",
				start_time: "",
				end_time: "",
				count: 1,
				count1: 1,
				size: 10,
				page: 1,
				cate: '',
				content: '',
				invitation_code: '',
				localhostPath: '',
				message: '',
        type: '',
        keywords: '',
        mouth_money: 0,
        year_money: 0,
        yc_mouth_money: 0,
        yc_year_money: 0,
			};
		},
		created() {
			document.title = '以图绘图印花设计网-我的推广';
			let wPath = window.document.location.href;
			let pathName = this.$route.path;
			let pos = wPath.indexOf(pathName);
			this.localhostPath = wPath.substring(0, pos);
			this.getCata();
			this.getMyPromotion();
			this.getMyReferrals();
			this.getMyEarnings();
		},
		methods: {
			onCopy() {
				this.$message({
					message: `复制成功！`,
					type: 'success'
				});
			},
			qrcode() {
				let aaa = "/login?invitation_code=" + this.invitation_code
				let qrcode = new QRCode("qrcode", {
					width: 200, // 二维码宽度，单位像素
					height: 200, // 二维码高度，单位像素
					text: this.localhostPath + aaa // 生成二维码的链接
				});
			},
			//获取顶部分区
			getCata() {
				topCate().then((res) => {
					// console.log(res)
					this.cate = res.data;
				});
			},
			//我的推广 - 我的推广
			getMyPromotion() {
				extensionMyPromotion().then((res) => {
					this.content = res.data.content
					this.invitation_code = res.data.invitation_code
					this.qrcode();
					this.message = this.localhostPath + "/login?invitation_code=" + this.invitation_code
				});
			},
			//我的推广 - 我的下线
			getMyReferrals() {
				extensionMyReferrals({
					page: this.page,
          type: this.type,
          keywords: this.keywords
				}).then((res) => {
					console.log(res)
					this.tableData = res.data.data
					this.count = res.data.total
				});
			},
			// 我的推广 - 我的收益
			getMyEarnings() {
				extensionMyEarnings({
					page: this.page
				}).then((res) => {
					this.tableData1 = res.data.data
					this.count1 = res.data.total
          this.mouth_money = res.data.mouth_money
          this.year_money = res.data.year_money
          this.yc_mouth_money = res.data.yc_mouth_money
          this.yc_year_money = res.data.yc_year_money
				});
			},
			go(aid) {
				this.$router.push({
					path: "/seller/manageDetail",
					query: {
						aid: aid,
					},
				});
			},
			goUpdata(aid) {
				this.$router.push({
					path: "/seller/manageUpdata",
					query: {
						aid: aid,
					},
				});
			},
      //推广级别搜索
      change() {
        this.getMyReferrals();
      },
      //搜索
      search() {
        this.getMyReferrals();
      },
			//分页
			handleCurrentChange(val) {
				this.page = val;
				this.getMyReferrals();
				this.getMyEarnings()
			},
			handleSelect(key, keyPath) {
				// console.log(key, keyPath);
				// alert(key);
				this.page = 1;
				this.activeIndex = key;
				this.getMyReferrals();
				this.getMyEarnings()
				// console.log(this.activeIndex)
			},
		},
	};
</script>
<style lang="less" scoped>
	.bottom {
		background: #ffffff;
		border-radius: 6px;
		padding: 23px 19px 23px 19px;

		.title {
			font-size: 20px;
			font-weight: 400;
			color: #08243c;
			line-height: 36px;
			padding-left: 4px;
		}

		.title::after {
			content: "";
			width: 83px;
			height: 9px;
			background: #e66617;
			display: block;
			margin-top: -15px;
		}

    .search-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 29px;

      .search {
        display: flex;
      }

      .partition {
        display: flex;
        align-items: center;

        .partition-text {
          font-size: 16px;
          font-weight: 400;
          color: #000000;
          line-height: 16px;
          padding-right: 29px;
        }
      }
    }
	}

  .top {
    background: #ffffff;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 35px 0px 38px 0px;

    .top-item {
      display: flex;
      align-items: center;
      flex-direction: column;

      .num {
        font-size: 24px;
        font-weight: bold;
        color: #08243c;
        line-height: 24px;
      }

      .text {
        font-size: 18px;
        font-weight: 400;
        color: #000000;
        line-height: 18px;
        padding-top: 20px;
      }
    }

    .shu {
      width: 1px;
      height: 37px;
      background: #d7dadd;
    }
  }

	/deep/.el-menu--horizontal>.el-menu-item.is-active {
		border-bottom: 2px solid #08243c;
	}

	.page-box {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 20px;
	}

	/deep/.el-table th {
		background: rgba(8, 36, 60, 0.04);
		font-size: 14px;
		font-weight: 400;
		color: #000000;
		line-height: 36px;
	}

	/deep/.el-table td {
		padding: 25px 0;
	}

	/deep/.el-pager li {
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		line-height: 32px;
	}

	/deep/.el-pager li.active {
		width: 32px;
		height: 32px;
		background: #08243c;
		border-radius: 50%;
	}

	/deep/.el-pager li.active {
		color: #ffffff;
	}

	/deep/.el-dialog,
	/deep/.el-pager li {
		background: none;
	}

	/deep/.el-pagination .btn-next,
	/deep/.el-pagination .btn-prev {
		background: none;
	}

	/deep/.el-pagination .btn-next .el-icon,
	/deep/.el-pagination .btn-prev .el-icon {
		font-size: 16px;
		line-height: 32px;
	}
</style>
